import React from "react";

import { DownOutlined } from "@ant-design/icons";
import { MenuProps, Typography } from "antd";
import { motion } from "motion/react";

import { Button } from "../Button";

import { AddFilterButton } from "./AddFilterButton";
import * as addFilterButtonTheme from "./AddFilterButton.css";
import { FilterBarProps } from "./FilterBar";
import * as theme from "./FilterBarHeaderActions.css";
import { FilterCountPill } from "./FilterCountPill";

interface FilterBarHeaderActionsProps {
    pendoIds?: FilterBarProps["pendoIds"];
    isHidden: boolean;
    setIsHidden: (hidden: boolean) => void;
    addLabel: string;
    hideFiltersLabel: string;
    getFilterCountLabel: (filterCount: number) => string;
    addFilterItems: MenuProps["items"];
    filterCount: number;
    rowCountLabel: React.ReactNode | undefined;
    onClearFilters: () => void;
    clearable?: boolean;
    hasFilters?: boolean;
}
export function FilterBarHeaderActions({
    isHidden,
    setIsHidden,
    addLabel,
    addFilterItems,
    hideFiltersLabel,
    getFilterCountLabel,
    filterCount,
    rowCountLabel,
    onClearFilters,
    clearable = true,
    hasFilters,
    pendoIds,
}: FilterBarHeaderActionsProps) {
    const countComponent = rowCountLabel ? (
        <Typography>{rowCountLabel}</Typography>
    ) : null;
    const hasAddFilterItems = (addFilterItems?.length ?? 0) > 0;
    return (
        <>
            <div className={theme.itemsContainer}>
                {!hasFilters && hasAddFilterItems && (
                    <div className={addFilterButtonTheme.container}>
                        <AddFilterButton
                            data-pendo={pendoIds?.add}
                            addLabel={addLabel}
                            items={addFilterItems}
                        />
                    </div>
                )}
                {hasFilters && (
                    <div className={theme.collapseContainer}>
                        <Button
                            data-pendo={pendoIds?.toggle}
                            onClick={() => setIsHidden(!isHidden)}
                        >
                            <div className={theme.collapseButtonContent}>
                                <motion.div
                                    animate={{ rotate: isHidden ? 0 : 180 }}
                                    transition={{ duration: 0.2 }}
                                    initial={false}
                                >
                                    <DownOutlined />
                                </motion.div>
                                {hideFiltersLabel}
                            </div>
                        </Button>
                    </div>
                )}

                {filterCount > 0 && isHidden && (
                    <div className={theme.filterCountPill}>
                        <FilterCountPill
                            closePendoId={pendoIds?.clearAll}
                            label={getFilterCountLabel(filterCount)}
                            closable={clearable}
                            onClose={onClearFilters}
                        />
                    </div>
                )}
                {countComponent}
            </div>
        </>
    );
}
